import * as ActionTypes from '../../constants/actiontypes/user';
import * as AuthActionTypes from '../../constants/actiontypes/auth';
import RepresentingUser from '../../constants/models/facilita/representingUser';
import * as Loadings from '../../constants/loadings/user';
import * as R from 'ramda';
import * as Text from '../../constants/toasterText/user';
import * as axios from 'axios';
import { toast } from 'react-toastify';
import User from '../../constants/models/user';
import ReferentAuth from '../../constants/models/referentAuth';
import { StaticRouter } from 'react-router';
import CardPaymentMethod from '../../constants/models/cardPaymentMethod';
import SepaPaymentMethod from '../../constants/models/sepaPaymentMethod';

const toastConf = {position: toast.POSITION.TOP_RIGHT, autoClose:3000};

const FacilitaReducer = (state = {
    isLoading: [],
    user: undefined,
    profilePicture: undefined,
    representing: []
    
}, action) => {
    switch(action.type){
        
        case ActionTypes.FETCH_USER_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCH_USER)){
                state.isLoading.push(Loadings.FETCH_USER);
            }
            return { ...state };
        case ActionTypes.FETCH_USER_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCH_USER);
                state.user = new User(action.data);
           
            return { ...state };
        case ActionTypes.FETCH_USER_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCH_USER);
            return { ...state };

        case ActionTypes.GET_PROFILEPIC_SUCCESS:
            state.profilePicture = action.data;
            return { ...state}
        case ActionTypes.DELETE_PROFILEPIC_SUCCESS:
            state.profilePicture = undefined;
            return { ...state }
        case ActionTypes.UPLOAD_PROFILEPIC_SUCCESS:
            state.profilePicture = action.data;
            return { ...state }
        
        case ActionTypes.FETCH_USERREPRESENTING_REQUEST:
                if (!state.isLoading.includes(Loadings.FETCH_USER)){
                    state.isLoading.push(Loadings.FETCH_USER);
                }
                return { ...state };
        case ActionTypes.FETCH_USERREPRESENTING_SUCCESS:
                state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCH_USER);

            if (action.data.length > 0) {
                
                    state.representing = action.data.map(m => new RepresentingUser(m));
            }  
                return { ...state };
            
        case ActionTypes.FETCH_USERREPRESENTING_FAILURE:
                state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCH_USER);
                return { ...state };

        case ActionTypes.AUTHENTICATE_FACILITA_REQUEST:
            state.signupStep4Success = false;
            if (!state.isLoading.includes(Loadings.AUTHENTICATING_USERREPRESENTING)) {
                state.isLoading = state.isLoading.concat(Loadings.AUTHENTICATING_USERREPRESENTING);
            }
            return { ...state };

        case ActionTypes.AUTHENTICATE_FACILITA_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.AUTHENTICATING_USERREPRESENTING);
            let referentAuth = new ReferentAuth(action.data);
            sessionStorage.setItem("access_token", referentAuth.jwtToken);
            axios.defaults.headers.common['Authorization'] = "Bearer " + referentAuth.jwtToken;    
            return { ...state };

        case ActionTypes.FETCH_USER_ADDRESS_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_USER_ADDRESSES)){
                state.isLoading.push(Loadings.FETCHING_USER_ADDRESSES);
            }
            return { ...state };
            
        case ActionTypes.FETCH_USER_ADDRESS_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_USER_ADDRESSES);
            return { ...state };

        case ActionTypes.FETCH_USER_ADDRESS_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.FETCHING_USER_ADDRESSES);
            if(!R.isNil(state.user)){
                state.user.addresses = action.addresses;
            }
            return { ...state };
            
        case ActionTypes.UPDATE_USER_ADDRESS_REQUEST:
            if (!state.isLoading.includes(Loadings.UPDATING_USER_ADDRESS)){
                state.isLoading.push(Loadings.UPDATING_USER_ADDRESS);
            }
            return { ...state };
            
        case ActionTypes.UPDATE_USER_ADDRESS_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_USER_ADDRESS);
            return { ...state };

        case ActionTypes.UPDATE_USER_ADDRESS_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATING_USER_ADDRESS);
            if(!R.isNil(state.user) && !R.isNil(state.user.addresses)){
                state.user.addresses = state.user.addresses.map((address) => {
                    if(address.id !== action.address.id){
                        return address;
                    }else{
                        return {...action.address}
                    }
                })
            }
            return { ...state };

        case ActionTypes.UPDATE_USER_REQUEST:
            if (!state.isLoading.includes(Loadings.UPDATE_USER)){
                state.isLoading.push(Loadings.UPDATE_USER);
            }
            return { ...state };
            
        case ActionTypes.UPDATE_USER_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATE_USER);
            return { ...state };

        case ActionTypes.UPDATE_USER_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.UPDATE_USER);
            state.user = {...action.user, addresses: state.user.addresses};
            return { ...state };

        case AuthActionTypes.SEND_OTP_CODE_REQUEST:
            if (!state.isLoading.includes(Loadings.SENDING_OTP)){
                state.isLoading.push(Loadings.SENDING_OTP);
            }
            return { ...state };

        case AuthActionTypes.SEND_OTP_CODE_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.SENDING_OTP);
            return { ...state };

        case AuthActionTypes.SEND_OTP_CODE_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.SENDING_OTP);
            return { ...state };

        case AuthActionTypes.VERIFY_OTP_REQUEST:
            if (!state.isLoading.includes(Loadings.VALIDATING_OTP)){
                state.isLoading.push(Loadings.VALIDATING_OTP);
            }
            return { ...state };

        case AuthActionTypes.VERIFY_OTP_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.VALIDATING_OTP);
            state.user = {...state.user, phoneNumber: action.phoneNumber}
            return { ...state };

        case AuthActionTypes.VERIFY_OTP_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.VALIDATING_OTP);
            return { ...state };
            
        case ActionTypes.GET_BILLINGCUSTOMERID_REQUEST:
            if (!state.isLoading.includes(Loadings.GETTING_BILLINGCUSTOMERID)){
                state.isLoading.push(Loadings.GETTING_BILLINGCUSTOMERID);
            }
            return { ...state };
            
        case ActionTypes.GET_BILLINGCUSTOMERID_FAILURE:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.GETTING_BILLINGCUSTOMERID);
            return { ...state };

        case ActionTypes.GET_BILLINGCUSTOMERID_SUCCESS:
            state.isLoading = state.isLoading.filter(s => s !== Loadings.GETTING_BILLINGCUSTOMERID);
            state.user = {...state.user, addresses: {...state.user.addresses}, stripeCustomerId: action.data};
            return { ...state };
            
        case ActionTypes.ADD_PAYMENTMETHOD_SUCCESS:
            for(let i = 0; i < state.user.paymentMethods.length; i++){
                state.user.paymentMethods[i].isDefault = false;
            }
            if(action.data.type === "Card"){
                state.user.paymentMethods = state.user.paymentMethods.concat(new CardPaymentMethod(action.data));
            }else if(action.data.type === "Sepa"){
                state.user.paymentMethods = state.user.paymentMethods.concat(new SepaPaymentMethod(action.data));
            }
            state.isLoading = state.isLoading.filter(c => c !== Loadings.ADDING_PAYMENTMETHOD)
            return {...state}

        case ActionTypes.ADD_PAYMENTMETHOD_REQUEST:
            if (!state.isLoading.includes(Loadings.ADDING_PAYMENTMETHOD)){
                state.isLoading = state.isLoading.concat(Loadings.ADDING_PAYMENTMETHOD);
            }
            return { ...state };            
        default:
            return state;
    }
}
export default FacilitaReducer;